/* eslint-disable react/forbid-prop-types */
import { useEffect } from 'react';
import * as pt from 'prop-types';

export default function UseEffect({ setup, deps = undefined }) {
  useEffect(setup, deps);
  return null;
}

UseEffect.propTypes = {
  setup: pt.func.isRequired,
  deps: pt.arrayOf(pt.any),
};
